import classNames from "classnames";
import styles from "./FormExpander.module.css";
import arrow_down from "../../assets/icons/chevron.svg";

import type { JSX } from "react";

type FormExpanderProps = {
  labelExpanded: string;
  labelCollapsed: string;
  isExpanded: boolean;
  onToggle: (expanded: boolean) => void;
};

const FormExpander = ({ labelExpanded, labelCollapsed, isExpanded, onToggle }: FormExpanderProps): JSX.Element => {
  const controlClasses = classNames(styles.control, {
    [styles.expanded]: isExpanded,
  });

  return (
    <button
      id="JobRadRechner_Form_Expander"
      className={controlClasses}
      onClick={() => {
        onToggle(!isExpanded);
      }}
      aria-expanded={isExpanded}
      aria-labelledby={"form-expander-label"}
      type="button"
    >
      <span id={"form-expander-label"} className={styles.label}>
        {isExpanded ? labelExpanded : labelCollapsed}
      </span>
      <span className={styles.icon}>
        <img src={arrow_down} alt={""} />
      </span>
    </button>
  );
};

export { FormExpander };
